import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const PublicRoute = () => {
    const location = useLocation();
    const { isLoggedIn } = useContext(AuthContext)
    return !isLoggedIn ? <Outlet /> : <Navigate to="/dashboard/" replace state={{from: location}} />
};
export default PublicRoute;